export default {
  id: 8,
  pride: 32768,
  slug: "brilliant-stars",
  category: "game",
  status: "archived",
  experienceable: false,
  titleKey: {
    zh: "璀璨群星",
    en: "Brilliant Stars"
  },
  image: require('@/assets/images/BS.webp'),
  descriptionKey: {
    zh: "一款类群星弹幕互动游戏。拿了B站的最佳弹幕游戏第二名。目前不可玩。",
    en: "A Stellaris-like interactive bullet comment game. Won second place for Best Bullet Comment Game on Bilibili. Currently not playable."
  },
  date: { year: 2022, month: 2 },
  genres: ["弹幕互动", "策略"],
  themes: ["太空"],
  engine: "虚幻引擎 4.26",
  platform: ["PC"],
  achievements: [
    { zh: "B站最佳弹幕游戏二等奖", en: "Bilibili Best Bullet Comment Game 2nd Prize" },
    { zh: "建立了最初的独立游戏粉丝群体", en: "Established the initial indie game fan base" }
  ],
  developerNotesKey: {
    zh: "类似Stellaris的弹幕互动游戏，在弹幕互动游戏火热期间推出。获Bilibili弹幕游戏二等奖。直播流水收入三四百。在同期大量跟风变现的弹幕互动游戏里，被评价为一股清流。建立了最初的独立游戏粉丝群体。",
    en: "A Stellaris-like interactive bullet comment game released during the genre's boom. Won 2nd prize on Bilibili. Stream revenue was around 300-400 RMB. Praised as a breath of fresh air among trend-chasing titles in the genre at the time. Established my initial indie game fan base."
  },
  tags: ["弹幕互动"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1c5411D7Qb/", textKey: { zh: "B站观看视频", en: "Watch Video on Bilibili" } }
  ]
};
